/**
 * Versão do sistema de cobranças
 * Esta versão é exibida na barra lateral para informar aos usuários sobre atualizações
 */
export const SYSTEM_VERSION = '2.0.61';

/**
 * Data da última atualização (formato: DD/MM/YYYY)
 */
export const LAST_UPDATE_DATE = '30/04/2026';
